var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-title"},[_vm._v("UNESCO moving forward the 2030 Agenda for Sustainable Development")]),_c('iframe',{staticClass:"pdf-iframe",staticStyle:{"display":"block"},attrs:{"src":"/UNESCO moving forward the 2030 Agenda for Sustainable Development_eng.pdf","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }